import { render, staticRenderFns } from "./ArchiveUpdate.vue?vue&type=template&id=06d4c25a&"
import script from "./ArchiveUpdate.vue?vue&type=script&lang=js&"
export * from "./ArchiveUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports